// extracted by mini-css-extract-plugin
export default {"active":"UniversalLink_active__LlqR8"};